import React, { FC } from 'react'
import * as styles from './ScoreSeparator.module.css'

const ScoreSeparator: FC = () => (
  <div className={styles.separator}>
    <div className={styles.dash} />
  </div>
)

export default ScoreSeparator
